<template>
  <div>
    <div class="Sub-menu mb-5">
      <div class="shadow-bottom">
        <ul class="nav nav-pills mb-3" role="tablist">
          <li
            v-for="item in tabs"
            :key="item.Id"
            :class="{
              'nav-item-Sub-menu px-5': showTab(item.Name),
              hidden: !showTab(item.Name),
              active: isActive(item.Name),
            }"
            @click="activeTab = item.Name"
          >
            <a
              class="nav-link no-margin-left"
              :class="{ active: isActive(item.Name) }"
              href="#tab-i"
              role="tab"
              aria-selected="true"
              aria-controls="tab-i"
              data-toggle="pill"
              @click.prevent="setActive(item.Id)"
            >
              {{ item.Caption }}
              <i
                v-if="IsValidTab(item)"
                class="fas fa-exclamation-triangle"
                style="color:red"
              />
            </a>
            {{ item.Tooltip }}
            <div class="nav-hover text-inf-student mt-2 mb-3">
              {{ item.Tooltip }}
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="tab-content">
      <keep-alive>
        <component
          :is="activeTab"
          ref="currentTab"
          v-bind="currentProperties"
        />
      </keep-alive>
    </div>
  </div>
</template>

<script>
import Tab1 from '@/components/at/tabs/Tab1';
import Tab2 from '@/components/at/tabs/Tab2';
import Tab3 from '@/components/at/tabs/Tab3';
import Tab4 from '@/components/at/tabs/Tab4';
import Tab5 from '@/components/at/tabs/Tab5';
import Tab6 from '@/components/at/tabs/Tab6';
import Tab7 from '@/components/at/tabs/Tab7';
import store from '@/store/index';

export default {
  components: {
    Tab1: Tab1,
    Tab2: Tab2,
    Tab3: Tab3,
    Tab4: Tab4,
    Tab5: Tab5,
    Tab6: Tab6,
    Tab7: Tab7,
  },
  data() {
    return {
      activeTab: 'Tab1',
      tabs: [
        {
          Id: 'Tab1',
          Name: 'Tab1',
          Caption: 'General',
          Tooltip: '',
        },
        { Id: 'Tab2', Name: 'Tab2', Caption: 'I' },
        { Id: 'Tab3', Name: 'Tab3', Caption: 'II-III' },
        {
          Id: 'Tab4',
          Name: 'Tab4',
          Caption: 'IV',
          Tooltip: '',
        },
        { Id: 'Tab5', Name: 'Tab5', Caption: 'V' },
        { Id: 'Tab6', Name: 'Tab6', Caption: 'VI' },
        { Id: 'Tab7', Name: 'Tab7', Caption: 'Documentos' },
      ],
      Tabs: {
        Name: 'AT Tab',
        Tab1Tab: {
          Name: '',
        },
        Tab2Tab: {
          Name: 'Tab II',
        },
        Tab3Tab: {
          Name: 'Tab III',
        },
        Tab4Tab: {
          Name: 'Tab IV',
        },
        Tab5Tab: {
          Name: 'Tab V',
        },
        Tab6Tab: {
          Name: 'Tab VI',
        },
        Tab7Tab: {
          Name: 'Tab VII',
        },
      },
      ValidationTriggered: store.getters.getatValidationTriggered,
    };
  },
  computed: {
    currentProperties: function() {
      return { Info: this.Tabs[this.activeTab + 'Tab'] };
    },
  },
  methods: {
    save() {
      this.$refs.currentTab.save();
    },  
    isActive(menuItem) {
      return this.activeTab === menuItem;
    },
    setActive(menuItem) {
      this.activeTab = menuItem;
    },
    showTab(name) {
      if (name == 'Tab3' || name == 'Tab5' || name == 'Tab6') {
        if (
          store.getters.SelectPreEvalAnswer == false &&
          store.getters.SelectRecentlyEvalBy == 1922
        ) {
          return false;
        }
      }
      return true;
    },
    IsValidTab(item) {
      if (!this.ValidationTriggered.validation) {
        return false;
      }
      let isValidTab = this.ValidationTriggered.validTabs.find(
        (x) => x.id == item.Id
      );
      return isValidTab ? isValidTab.value : true;
    },
  },
};
</script>

<style scope>
.no-margin-left {
  margin-left: 0px !important;
}
.hidden {
  display: none;
}
.nav-item-Sub-menu.active {
  background-color: #ff7058;
}
</style>
